import React, { Children, useEffect, useState } from 'react';
import "../../screens/css/customMenu.css"
import Icon,{ AimOutlined, BankOutlined, CodepenOutlined, DashboardFilled, DashboardOutlined, GiftOutlined, HistoryOutlined, IdcardFilled, IdcardOutlined, LogoutOutlined, MoneyCollectOutlined, PieChartOutlined, ReadOutlined, SnippetsOutlined, StarTwoTone, SyncOutlined, TeamOutlined, UserOutlined,  CalendarOutlined} from '@ant-design/icons';
import { Badge, Button, Menu, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {  CopyOutlined } from "@ant-design/icons";

import { useGetAngelProfileQuery, useGetBankDetailsQuery, useGetCecmasMutation, useLogoutMutation } from '../../slices/usersApiSlice';
import { setLogout } from '../../slices/authSlice';
// import Tooltip from "@mui/material/Tooltip";
import Grid from 'antd/es/card/Grid';
import ApiIcon from '@mui/icons-material/Api'; // Replace with suitable icon
import {  useMediaQuery, useTheme, Avatar } from '@mui/material';
import { useKiteProfileMutation, useLogoutZerodhaMutation } from '../../slices/usersApiSlice';
import SimpleDialogDemo from './zerodhaDilogbox';
import SimpleDialog from './zerodhaDilogbox';
import angelone from "../../images/angelone.png";
import strategy from "../../images/strategy.png";
import { Tooltip, message } from "antd";


const CalendarLogo = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    fill="none"
    stroke="currentColor"
    strokeWidth="5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Calendar"
  >
    <rect x="2.5" y="7.5" width="59" height="54" rx="6" />
    <path d="M17 2.5 V12.5" />
    <path d="M47 2.5 V12.5" />
    <path d="M2.5 22 H61.5" />
    <path d="M14.5 35.5 H19.5" />
    <path d="M29.5 35.5 H34.5" />
    <path d="M44.5 35.5 H49.5" />
    <path d="M14.5 48 H19.5" />
    <path d="M29.5 48 H34.5" />
    <path d="M44.5 48 H49.5" />
  </svg>
);

const Sidebar = () => {
  const [gcemas] = useGetCecmasMutation();
  const [logoutmu] = useLogoutMutation();
  const [fetchKiteProfile] = useKiteProfileMutation();
  const [logoutZerodha] = useLogoutZerodhaMutation();
  const [currentPlan, setCurrentPlan] = useState(null);
  const [admin, setAdmin] = useState(false);
  const [kiteProfile, setKiteProfile] = useState(null);

  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isMobile1, setIsMobile] = useState(window.innerWidth < 768);
const [openDialog, setOpenDialog] = useState(false);
  const { userInfo } = useSelector((state) => state.auth);
  const userId = userInfo?._id || localStorage.getItem('userId');
  const { data: angelProfile, error: angelError } = useGetAngelProfileQuery(userId);
  const { darkmode } = useSelector((state) => state.darkmode);
const{data:bankdetails}=useGetBankDetailsQuery();
const isPartner = userInfo?.role === "Partner";
// console.log(bankdetails);
// console.log(isPartner);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const getmas = async () => {
      const res = await gcemas().unwrap();
      setAdmin(res.user);
    };

    const fetchProfile = async () => {
      try {
        const res = await fetchKiteProfile().unwrap();
        setKiteProfile(res.data); // Adjust if needed
      } catch (err) {
        console.log('Kite not connected:', err.message);
        // message.error(err.message);
      }
    };

    getmas();
    fetchProfile();
  }, []);
  // const handleClose = () => {
  //   onClose(selectedValue);
  // };
  const handlelogout = async () => {
    const res = await logoutmu();
    dispatch(setLogout({ ...res }));
    window.location.href = "/Login";
  }

  const getmas = async () => {
    const res = await gcemas().unwrap();
    setAdmin(res.user);
  }
  useEffect(() => {
    getmas();
  }, [])

const copySponsorId = () => {
  navigator.clipboard.writeText(userId);
  message.success("Sponsor ID copied");
};
const navigate = useNavigate();

const handleWithdrawClick = () => {
  if (!bankdetails || bankdetails.length === 0) {
    message.warning("Please add bank details first");
    navigate("/bank-details");
  } else {
    navigate("/withdraw");
  }
};
  const items = [
    {
      key: 'dashboard',
      label: (
        <Link to='/Dashboard' rel="noopener noreferrer">
          Dashboard
        </Link>
      ),
      icon: <DashboardOutlined />,
      to: "/Dashboard"
    },
    {
      type: 'divider',
    },
    {
      key: 'dailyjournal',
      label: (
        <Link to='/DailyJournal' rel="noopener noreferrer">
          Daily Journal
        </Link>
      ),
      icon: <ReadOutlined />,
      to: "/DailyJournal"
    },
    {
      type: 'divider',
    },
    {
      key: 'tradelogs',
      label: (
        <Link to='/TradeLogs' rel="noopener noreferrer">
          Trade Logs
        </Link>
      ),
      icon: <HistoryOutlined />,
      to: "/TradeLogs"
    },
    {
      type: 'divider',
    },
    {
      key: 'reports',
      label: (
        <Link to='/Reports' rel="noopener noreferrer">
          Reports
        </Link>
      ),
      icon: <SnippetsOutlined />,
      to: "/Reports"
    },
    {
      type: 'divider',
    },
    {
      key: 'Cources',
      label: (
        <Link to='/courses' rel="noopener noreferrer">
          Courses
        </Link>
      ),
      icon: <BankOutlined />,
      to: "/cources"
    },
     {
      type: 'divider',
    },
    {
  key: 'portfolio',
  label: 'Portfolio',
  icon: <PieChartOutlined />,
  children: [
    {
      key: 'angelone-portfolio',
      label: 'AngelOne',
      children: [
        {
          key: 'angelone-holdings',
          label: (
            <Link to="/angelone-holdings">
              Holdings
            </Link>
          ),
        },
        {
          key: 'angelone-positions',
          label: (
            <Link to="/angelone-positions">
              Positions
            </Link>
          ),
        },
      ],
    },
    {
      key: 'groww-portfolio',
      label: 'Groww',
      children: [
        {
          key: 'groww-holdings',
          label: (
            <Link to="/groww-holdings">
              Holdings
            </Link>
          ),
        },
        {
          key: 'groww-positions',
          label: (
            <Link to="/groww-positions">
              Positions
            </Link>
          ),
        },
      ],
    },
  ],
},

{
  key: 'calender',
  label: (
    <Link to="/calender" rel="noopener noreferrer">
      Calendar
    </Link>
  ),
  icon: <Icon component={CalendarLogo} />,
  to: "/calender",
},
//       {
//   key: 'downline',
//   label: (
//     <Link to="/downline">
//       Downline
//     </Link>
//   ),
//   icon: <TeamOutlined />,
//   to: "/downline"
// },
 {
      type: 'divider',
    },
{
  key: 'strategy',
  label: 'Strategies',
 icon: <img src={strategy} alt='angle-one-logo' style={{ height: '15px' , 
      filter: darkmode ? "invert(1)" : "none",
}} />,
  children: [
    {
      key: 'all-strategies',
      label: (
        <Link to='/all-Strategy'>
          All Strategies
        </Link>
      ),
    },
    {
      key: 'create-strategy',
      label: (
        <Link to='/create-strategy'>
          Create Strategy
        </Link>
      ),
    },
  ],
}, {
      type: 'divider',
    },
  isPartner && {
    key: 'downline',
    label: <Link to='/downline'>Downlines</Link>,
    icon: <UserOutlined />,
  },
  // {
  //     key: 'apikey',
  //     label: (
  //       <Link to='/apikeyform' rel="noopener noreferrer">
  //         growwApiKey
  //       </Link>
  //     ),
  //     icon: <SnippetsOutlined />,
  //     to: "/apikeyform"
  //   },
isPartner && {
  key: 'wallet',
  label: 'Wallet',
  icon: <MoneyCollectOutlined />,
  children: [
    {
      key: 'bank-details',
      label: (
        <Link to='/bank-details'>
          Bank Details
        </Link>
      ),
    },
    
    {
      key: 'withdraw',
      label: (
        <span onClick={() => handleWithdrawClick()}>
          Withdrawal
        </span>
      ),
    },
     {
      key: 'wallet-history',
      label: (
        <Link to='/wallet-history'>
          WalletHistory
        </Link>
      ),
    },
  ],
},

    admin ?
      {
        key: 'Admin',
        label: "Admin",
        icon: <StarTwoTone twoToneColor={"#f1c40f"} />,
        children: [
          {
            key: 'Dashboard',
            label: (
              <Link to='/Lincfolioadm/dashboard' rel="noopener noreferrer">
                Dashboard
              </Link>
            ),
            icon: <DashboardFilled />,
          },
          {
            key: 'Users',
            label: (
              <Link to='/Lincfolioadm/users' rel="noopener noreferrer">
                Users
              </Link>
            ),
            icon: <UserOutlined />,
          },
          {
            key: 'Payments',
            label: (
              <Link to='/Lincfolioadm/payments' rel="noopener noreferrer">
                Payments
              </Link>
            ),
            icon: <MoneyCollectOutlined />,
          },
          {
            key: 'Packages',
            label: (
              <Link to='/Lincfolioadm/packages' rel="noopener noreferrer">
                Packages
              </Link>
            ),
            icon: <GiftOutlined />,
          },
          {
            key: 'Courses',
            label: (
              <Link to='/Lincfolioadm/courses' rel="noopener noreferrer">
                Course
              </Link>
            ),
            icon: <CodepenOutlined />,
          },
            {
      key: 'wallet-history',
      label: (
        <Link to='/Lincfolioadm/walletHistory'>
          wallet-History
        </Link>
      ),
      icon: <CodepenOutlined />,
       },
        ]
      } : "",
    {
      type: 'divider',
    },
{
  key: 'connect-broker',
  label: 'Connect Broker',
  icon: <SyncOutlined />
},
  angelProfile?.data?.name &&
 {
    key: 'broker-ac',
    label: (
      <Tooltip title={angelProfile?.data?.name} placement="right">
        <Typography.Text ellipsis style={{ maxWidth: 120 }}>
          angelone
        </Typography.Text>
      </Tooltip>
    ),
    icon: <img src={angelone} alt='angle-one-logo' style={{ height: '15px' }} />,
    children: [
      {
        key: 'broker-logout',
        label: (
          <>
            <SimpleDialogDemo />
            <Typography.Text>logout</Typography.Text>
          </>
        ),
        icon: <LogoutOutlined style={{ color: "#e74c3c" }} />,
      }
    ]
  }
,

// ✅ ALWAYS SHOW

    // angelProfile?.data?.name ?
    //   {
    //     key: 'broker-ac',
    //     label: (
    //       <Tooltip
    //         title={angelProfile?.data?.name} // full name shown on hover
    //         placement="right"
    //       >
    //         <Typography.Text ellipsis style={{ maxWidth: 120 }}>
    //           angelone
    //         </Typography.Text>
    //       </Tooltip>
    //     ),
    //     icon: <img src={angelone} alt='angle-one-logo' style={{ height: '15px' }} />,
    //     children: [
    //       {
    //         key: 'broker-logout',
    //         label: (
    //           <>
    //             <SimpleDialogDemo />
    //          <Tooltip
    //         title={angelProfile?.data?.name} // full name shown on hover
    //         placement="right"
    //       >
    //         <Typography.Text ellipsis style={{ maxWidth: 120 }}>
    //           logout
    //         </Typography.Text>
    //       </Tooltip>
    //         </>
    //         ),
    //         icon: <LogoutOutlined style={{ color: "#e74c3c" }} />,
    //       }
    //     ]
    //     } :
      //  {
      //   key: 'Connect Broker',
      //   label: (
      //     <>
      //       <SimpleDialogDemo />
      //     </>
      //   ),
      //   icon: <SyncOutlined />
      // },
//       {
//   key: 'connect-broker',
//   label: 'Connect Broker',
//   icon: <SyncOutlined />
// },

    // {
    //   key: 'ChatBot',
    //   label: (
    //     <Link to='/chat-bot' rel="noopener noreferrer">
    //       Chatbot
    //     </Link>
    //   ),
    //   icon: <BankOutlined />,
    //   to: "/ChatBot"
    // },

   ]

  // const onClick = (e) => {
  //   console.log('click ', e);
  // };
const onClick = (e) => {
  if (e.key === 'connect-broker') {
    setOpenDialog(true);
  }
};
// const onClick = (e) => {
//   console.log('click ', e);

//   if (e.key === "Connect Broker") {
//     handleClickOpen();   // 👈 Dialog open
//   }

//   if (e.key === "broker-logout") {
//     handleLogout();      // 👈 Logout
//   }
// };
  const handleLogoutZerodha = async () => {
    try {
      // setIsLoggingOut(true);
      await logoutZerodha().unwrap(); // unwrap to handle success or error manually
      // Optionally, redirect to login page or clear any user-specific state
      window.location.href = '/login'; // Or use React Router to navigate
    } catch (err) {
      console.error('Logout failed: ', err);
    } finally {
      // setIsLoggingOut(false);
    }
  };
return ( 
  <>
 
{/* <div style={{ position: 'relative', height: '100vh', color: '#ffff' }}>
   <Menu onClick={onClick} mode='inline' items={items} 
   
   theme={darkmode ? "dark" : "light"} 
  //  style={{ borderRight: 'none' }}
   
   style={{
    borderRight: 'none',
    backgroundColor: darkmode ? "#0a0a0a" : "#ffffff",
  }}
  className={`custom-menu ${darkmode ? "menu-dark" : "menu-light"}`}
   />
    </div> */}
    
<div className="sidebar-menu-container">
  <Menu
    onClick={onClick}
    mode="inline"
    items={items.filter(Boolean)}
    theme="dark"
    className="custom-menu"
    style={{
      borderRight: "none",
      backgroundColor: "#0b0b0b",
    }}
  />
</div>

<SimpleDialogDemo
  open={openDialog}
  onClose={() => setOpenDialog(false)}
/>
   </>
  
  ); }; 
  export default Sidebar;
